import styled from '@emotion/styled';

export const CurrencyWrapper = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
}));

export const CurrencyIcon = styled.img((props) => ({
  width: 22,
  height: 22,
}));
